import { defineComponent } from 'vue';
import LoadingWrapper from '@/presentation/components/loading-wrapper/loading-wrapper.vue';
import ActiveDashboardsOverviewCode from '@/presentation/components/active-dashboards-overview/active-dashboards-overview.code';

export default defineComponent({
	components: {
		LoadingWrapper
	},
	setup: () => {
		const code = new ActiveDashboardsOverviewCode();

		return {
			isLoading: code.isLoading,
			activeDashboards: code.activeDashboards,
			retrieveIconUrlForDashboard: code.retrieveIconUrlForDashboard.bind(code),
			retrieveAccessLabel: code.retrieveAccessLabel.bind(code),
			navigateToDashboard: code.navigateToDashboard.bind(code)
		};
	}
});
